export * from './product-upload-popover-props';

export const APP_NAME = 'assortment';
